import React from 'react';
import { Link } from 'react-router-dom';
import '../css/WPP8M.css';

const Terminos = () => {
    return (
        <div className="wpp8m-page">

            {/* HEADER */}
            <header className="wpp8m-header">
                <a href="https://www.wpp.com" target="_blank" rel="noopener noreferrer" className="wpp8m-header-logo">
                    <img src="https://www.wpp.com/assets/img/WPP-logo.svg" alt="WPP" className="wpp8m-header-logo-img" />
                    <span className="wpp8m-header-logo-text">Mes de la Mujer</span>
                </a>
                <div className="wpp8m-header-badge">
                    <span className="wpp8m-badge-8m">#DarParaGanar</span>
                </div>
            </header>

            {/* CONTENT */}
            <main className="terminos-main">
                <div className="terminos-container">
                    <span className="wpp8m-tag">WPP · Uruguay</span>
                    <h1 className="terminos-title">Términos y<br /><span>condiciones</span></h1>
                    <div className="wpp8m-left-divider" style={{ margin: '24px 0 36px' }}></div>

                    <div className="terminos-body">
                        <p><strong>Términos y Condiciones de Participación en la Jornada de Mentoría de WPP</strong></p>
                        <p>Al participar en la jornada de mentoría de WPP, se acepta que todo el contenido presentado, generado e intercambiado en el marco de esta iniciativa es confidencial y de propiedad exclusiva de WPP.</p>
                        <p>Al inscribirse, los participantes aceptan estos términos y condiciones y no podrán utilizar el contenido sin autorización escrita de WPP.</p>
                        <p>Es condición excluyente que los participantes sean estudiantes de comunicación y marketing y que, al momento de aplicar y hasta culminar la jornada de mentoría, no se encuentren trabajando en ninguna agencia de marketing y/o publicidad.</p>
                        <p>Los cupos son limitados.</p>
                    </div>

                    <Link to="/" className="terminos-back-btn">
                        ← Volver al formulario
                    </Link>
                </div>
            </main>

            {/* FOOTER */}
            <footer className="wpp8m-footer">
                <p>© 2026 WPP. Todos los derechos reservados.</p>
            </footer>

        </div>
    );
};

export default Terminos;
